import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  Card,
  CardContent,
} from '@mui/material';
import { withStyles } from '@mui/styles';

import { AffiliatedIcon } from './AffiliatedIcon';
import { TitleTooltip } from './TitleTooltip';
import { DynamicTable } from './DynamicTable'; 
import { VisitsSparkline } from './VisitsSparkline';

import {
  StoreUtil,
} from 'doctivity-shared/utils';
import { withRouter } from 'utils';
import {
  loadAnalytics,
} from 'store/actions/analyticsActions';

const styles = (theme) => ({
  card: {
    marginTop: theme.spacing(3),
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  leftIcon: {
    marginRight: theme.spacing(),
  },
  nothingFound: {
    fontWeight: 300,
    fontSize: 12,
  },
});

class TopReferralsInTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      query: {
        limit: 50,
        offset: 0,
      },
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.providerId !== prevProps.providerId ||
      this.props.clientId !== prevProps.clientId ||
      this.props.department !== prevProps.department ||
      this.props.referringOrganization !== prevProps.referringOrganization ||
      this.props.providerLabelId !== prevProps.providerLabelId ||
      this.props.referrerLabelId !== prevProps.referrerLabelId ||
      this.props.app.dateRange !== prevProps.app.dateRange
    ) {
      this.fetchData();
    }
  }

  fetchData() {
    const { dispatch, providerId, clientId, department } = this.props;

    dispatch(
      loadAnalytics({
        type: 'TOP_REFERRERS_BY_PROVIDER',
        filter: {
          provider_id: providerId,
          client_id: clientId,
          department,
          referring_organization: this.props.referringOrganization,
          provider_tag_id: this.props.providerLabelId,
          referrer_tag_id: this.props.referrerLabelId,
        },
        opts: {
          ...this.state.query,
          from: this.props.app.dateRange.start,
          to: this.props.app.dateRange.end,
        },
      })
    );
  }

  render() {
    const { classes, data, providerId } = this.props;

    const noDataMessage = 'No referrals recieved.';
    return (
      <Card className={classes.card}>
        <CardContent>
          <DynamicTable
            ContainerType={React.Fragment}
            header={
              <TitleTooltip
                title={
                  this.props.providerId
                    ? ''
                    : 'Top Referrers'
                }
              />
            }
            idKey='referrer_id'
            columns={[
              {
                label: '',
                sortable: false,
                showFilter: false,
                key: 'referrer.clients.id',
                type: 'bool',
                format: (value) => value ? <AffiliatedIcon /> : '',
                style: { width: 16 },
              },
              {
                label: 'Referring Provider',
                key: 'referrer',
                sortable: false,
                format: (value) =>
                  value
                    ? `${value.last_name}, ${value.first_name} ${value.middle_name}`
                    : '',
              },
              {
                label: 'Count',
                key: 'count',
                style: { width: 100 },
              },
              {
                label: 'Trend',
                key: 'referrer_id',
                format: (id) => {
                  if (id) {
                    return (
                      <VisitsSparkline
                        providerId={providerId}
                        referrerId={id}
                        providerLabelId={this.props.providerLabelId}
                        referrerLabelId={this.props.referrerLabelId}
                      />
                    );
                  }
                  return 'nope';
                },
                style: { width: 60, verticalAlign: 'top' },
                sortable: false,
                showFilter: false,
              },
            ]}
            showFilters={false}
            isso
            query={this.state.query}
            data={data}
            noDataMessage={noDataMessage}
            getRowHref={this.getRowHref}
            onQueryChange={this.onQueryChange}
          />
        </CardContent>
      </Card>
    );
  }

  onQueryChange = (query) => {
    this.setState(
      {
        query,
      },
      () => {
        this.fetchData();
      }
    );
  };

  getRowHref = (row) => {
    return `/providers/${row.referrer_id}/visits`;
  };
}

TopReferralsInTable.propTypes = {
  dispatch: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired,
  classes: PropTypes.object,
  app: PropTypes.object,
  data: PropTypes.object,
  providerId: PropTypes.number,
  clientId: PropTypes.number.isRequired,
  department: PropTypes.string,
  referringOrganization: PropTypes.string,
  providerLabelId: PropTypes.number,
  referrerLabelId: PropTypes.number,
};

function mapStateToProps(state) {
  const {
    analytics,
    app,
  } = state;

  return {
    app,
    data: StoreUtil.get(analytics, 'TOP_REFERRERS_BY_PROVIDER'),
  };
}

const styled = withStyles(styles)(TopReferralsInTable);
const connected = connect(mapStateToProps)(styled);
const routed = withRouter(connected);
export { routed as TopReferralsInTable };
